import { render, staticRenderFns } from "./LongForm.vue?vue&type=template&id=1c591080&scoped=true"
import script from "./LongForm.vue?vue&type=script&lang=js"
export * from "./LongForm.vue?vue&type=script&lang=js"
import style0 from "./LongForm.vue?vue&type=style&index=0&id=1c591080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c591080",
  null
  
)

export default component.exports